import {pixiClearTimeout, pixiSetTimeout} from "../framework/src/engine/pixi/pixiTimeout";

export default class IdleWin {

    constructor (commander) {
        this.commander = commander;
        this.NormalWin = this.commander.NormalWin;
        this.BlinkAnimation = this.commander.BlinkAnimation;

        this.end = true;
        this.timer = undefined;
    }

    run(result) {
        return new Promise(async res => {
            this.end = false;
            this.timer = pixiSetTimeout(60, this.stop.bind(this));
            if (this.commander.freespins.isInFreeSpins()) {
                this.commander.audio.fadeToTrack("bg_FreeSpins_Loop", 1, 1000);
            }

            while (!this.end) {
                for (let line of result.lineWins) {
                    if (this.end) {
                        break;
                    } else {
                        this.NormalWin.setWinPositions(line.position);
                        this.NormalWin.setMaskWidth(line.position.length);
                        this.NormalWin.drawFrames();
                        this.NormalWin.showLine(line.line);
                        await new Promise(resolve => pixiSetTimeout(1, resolve)).then(() => {
                            this.NormalWin.resetWinPositions();
                            this.NormalWin.hideFrames();
                            this.NormalWin.hideLine(line.line);
                            this.BlinkAnimation.clearTargetFilters();
                        });
                    }
                }
            }
            res();
        });
    }

    stop() {
        this.end = true;
        if (this.timer !== undefined)
            pixiClearTimeout(this.timer);
        this.NormalWin.hideLines();
        this.NormalWin.hideFrames();
        this.BlinkAnimation.clearTargetFilters();
    }
}